import logoGreen from "../assets/logo-green.png";
import logoWhite from "../assets/logo-white.png";

export default function Logo({ dark = false, className = "", testId = "nav-brand-logo" }) {
  const src = dark ? logoWhite : logoGreen;
  return (
    <span className={`inline-flex items-center ${className}`}>
      <img
        src={src}
        alt="CareCraft"
        data-testid={testId}
        className={dark ? "h-10 w-auto" : "h-11 w-auto rounded-lg"}
      />
    </span>
  );
}
